<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NcVMLp/tc-custom/9781607059523.jpg?1737678476441" alt="This image is the cover for the book Patchwork City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Patchwork City
      </h1>
      <p class="bookDescription body article font2">
        <b>Bored with sewing the same old blocks? Get a bonanza of 75 modern quilt blocks from a bestselling modern designer! </b><br/><br/>You’ll love these fresh angular designs inspired by city life, and the mix-and-match possibilities are endless! Elizabeth Hartman gets you started with six complete sampler quilts to sew. Each block is shown in three different fabric palettes. <br/><br/>The book includes easy-to-follow cutting charts and instructions for every block. Some have links to full-size freezer-paper templates. Change up blocks, sizes, or fabrics to embark on a limitless exploration of modern style.<br/><br/>“The instructions are straightforward . . . an excellent choice for quilting collections.” —<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Hartman
      </h2>
      
      <p class="authorDescription body article">Elizabeth Hartman is a quilter, designer, craftsy.com instructor, and author of the best-selling quilting guides The Practical Guide to Patchwork and Modern Patchwork. Elizabeth's blog, ohfransson.com, has introduced thousands of people to modern quilting. She lives in Portland, Oregon.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?850456be